import getFolderTable from './getFolderTable';

export default function getAllSubFolderIds(folderId: string): string[] {
    const folderIds = [folderId];

    const folder = getFolderTable().get(folderId);
    folder.childFolderIds.forEach((childFolderId: string) => {
        Array.prototype.push.apply(folderIds, getAllSubFolderIds(childFolderId));
    });

    return folderIds;
}
